__webpack_require__.p = "https://app.withvector2.com/";